export default "__VITE_ASSET__4671a1f0__"